import { type Inline, NODE_DATA_INVALID, Schema } from '@gitbook/slate';

import { BLOCK_MATH, INLINE_MATH } from '../types';
import { setFormula } from './utils';

/**
 * Schema to validate math nodes.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_MATH]: {
            isVoid: true,
            data: {
                formula: (tex) => typeof tex === 'string' && tex.trim().length > 0,
            },
        },
    },
    inlines: {
        [INLINE_MATH]: {
            isVoid: true,
            data: {
                formula: (tex) =>
                    typeof tex === 'string' && tex.trim().length > 0 && tex.indexOf('\n') < 0,
            },
            normalize: Schema.createNormalize<Inline>({
                [NODE_DATA_INVALID]: (change, { node }) => {
                    const formula = node.data.get('formula');

                    if (!formula || typeof formula !== 'string' || !formula.trim()) {
                        change.removeNodeByKey(node.key);
                    } else {
                        setFormula(change, node, formula);
                    }

                    return change;
                },
            }),
        },
    },
});
